import { supabase } from '../lib/supabase';

export interface DiocesisEstado {
  id: string;
  diocesis_id: string;
  estado_iso2: string;
  pais_iso2: string;
  estado_nombre: string;
  created_at: string;
}

/** Resultado extendido con info de la diócesis para mostrar "asignado a X" */
export interface DiocesisEstadoConDiocesis extends DiocesisEstado {
  diocesis_nombre?: string;
}

export const diocesisEstadosService = {
  /** Listar estados asignados a una diócesis */
  async listarPorDiocesis(diocesisId: string): Promise<DiocesisEstado[]> {
    const { data, error } = await supabase
      .from('diocesis_estados')
      .select('*')
      .eq('diocesis_id', diocesisId)
      .order('estado_nombre', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  /** Listar todos los estados asignados en una provincia eclesiástica (con nombre de diócesis) */
  async listarAsignadosPorProvincia(provinciaId: string): Promise<DiocesisEstadoConDiocesis[]> {
    const { data, error } = await supabase
      .from('diocesis_estados')
      .select('*, diocesis!inner(nombre, provincia_eclesiastica_id)')
      .eq('diocesis.provincia_eclesiastica_id', provinciaId)
      .order('estado_nombre', { ascending: true });

    if (error) throw error;

    return (data || []).map((row) => ({
      id: row.id,
      diocesis_id: row.diocesis_id,
      estado_iso2: row.estado_iso2,
      pais_iso2: row.pais_iso2,
      estado_nombre: row.estado_nombre,
      created_at: row.created_at,
      diocesis_nombre: row.diocesis?.nombre,
    }));
  },

  /** Guardar asociaciones de forma atómica: elimina las previas e inserta las nuevas */
  async guardarAsociaciones(
    diocesisId: string,
    estados: Array<{ estado_iso2: string; pais_iso2: string; estado_nombre: string }>
  ): Promise<void> {
    // Eliminar asociaciones previas
    const { error: deleteError } = await supabase
      .from('diocesis_estados')
      .delete()
      .eq('diocesis_id', diocesisId);

    if (deleteError) throw new Error(`Error al eliminar asociaciones previas: ${deleteError.message}`);

    // Insertar nuevas (si hay)
    if (estados.length > 0) {
      const rows = estados.map(e => ({
        diocesis_id: diocesisId,
        estado_iso2: e.estado_iso2,
        pais_iso2: e.pais_iso2,
        estado_nombre: e.estado_nombre,
      }));

      const { error: insertError } = await supabase
        .from('diocesis_estados')
        .insert(rows);

      if (insertError) throw new Error(`Error al guardar asociaciones: ${insertError.message}`);
    }
  },
};
